module.exports = __webpack_public_path__ + "img/independent2.6a31d936.png";